import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Table } from 'react-bootstrap'
import IosSwitch from 'react-ios-switch'
import { useStateValue } from '../../state'
import { client } from '@Utils'
import { RemoveConfirmModal } from '../modals/RemoveConfirmModal'
import ButterToast, { Cinnamon } from 'butter-toast'
import { EditIssuerModal } from '../modals/EditIssuerModal'

export const Issuer = ({ match }) => {
  const [currentState, dispatch] = useStateValue()

  const [showIssuerEditModal, setShowIssuerEditModal] = useState(false)

  const [removeContextModalOpen, toggleRemoveModal] = useState(false)
  const [removeContextURL, setRemoveContextURL] = useState('')
  const [removeContextMessage, setRemoveContextMessage] = useState('')

  useEffect(() => {
    const getClients = async () => {
      try {
        let resp = await client.get(
          `/account/admin_lti13.getClients/-/${match.params.issuerId}/`
        )
        dispatch({ type: 'updateMessage', message: null })
        dispatch({ type: 'updateIssuer', issuer: resp.data.issuer })
        dispatch({
          type: 'updateClientsTable',
          clientsTableData: resp.data.clients,
        })
      } catch (err) {
        if (err.response) {
          dispatch({ type: 'updateMessage', message: err.response.statusText })
          ButterToast.raise({
            content: (
              <Cinnamon.Crisp
                title={err.response.statusText}
                content={err.response.data.error}
                scheme={Cinnamon.Crisp.SCHEME_RED}
                icon={<i className="far fa-thumbs-down fa-3x" />}
              />
            ),
          })
        } else {
          dispatch({ type: 'updateMessage', message: err })
        }
      }
    }
    getClients()
  }, [currentState.reloadSwitch])

  const openModal = contextObject => {
    setRemoveContextURL(
      `/account/admin_lti13.deleteClient/-/${contextObject.id}/`
    )
    setRemoveContextMessage(
      `Are you sure you want to remove Client: ${contextObject.data.name}?`
    )
    toggleRemoveModal(true)
  }

  return (
    <div className="container" style={{ width: '100%' }}>
      <div className="mb-2">
        <Link
          className="btn btn-default btn-myed btn-default-myed btn-sm-myed mr-4"
          to={`/account/admin_lti13/-/platforms/${match.params.lmsCode}/issuers`}
        >
          <div className="far fa-arrow-circle-left fa-fw mr-2" /> Go Back
        </Link>
      </div>
      <div className="card-myed">
        <div className="pi-info pull-right">
          <button
            onClick={() => setShowIssuerEditModal(true)}
            className="btn btn-sm btn-sm-myed btn-primary"
          >
            Edit <i className="far fa-edit" />
          </button>
        </div>
        <h3>
          Issuer: {currentState.platform && currentState.platform.data.name}
        </h3>

        {currentState.issuer && (
          <div>
            <div className="pull-right">
              <p>Enable LTI 1.3 Connection: </p>
              <IosSwitch
                style={{ transform: 'scale(0.6)' }}
                onChange={async () => {
                  let data = {
                    lti_login: !currentState.issuer.data.lti_login,
                  }
                  try {
                    let resp = await client.post(
                      `/account/admin_lti13.lti_login/-/${match.params.issuerId}`,
                      data
                    )
                    dispatch({ type: 'updateIssuer', issuer: resp.data.issuer })
                    ButterToast.raise({
                      content: (
                        <Cinnamon.Crunch
                          title="LTI Login Status Updated!"
                          content={`LTI login is now: ${
                            resp.data.issuer.data.lti_login
                              ? 'Enabled'
                              : 'Disabled'
                          }`}
                          scheme={
                            resp.data.issuer.data.lti_login
                              ? Cinnamon.Crisp.SCHEME_GREEN
                              : Cinnamon.Crisp.SCHEME_ORANGE
                          }
                          icon={
                            resp.data.issuer.data.lti_login ? (
                              <i className="far fa-check fa-3x" />
                            ) : (
                              <i className="far fa-exclamation-triangle fa-3x" />
                            )
                          }
                        />
                      ),
                    })
                  } catch (err) {
                    ButterToast.raise({
                      content: (
                        <Cinnamon.Crunch
                          title="Error"
                          content={`There was an error trying to toggle the Login status: ${err}`}
                          scheme={Cinnamon.Crisp.SCHEME_RED}
                          icon={
                            <i className="far fa-exclamation-triangle fa-3x" />
                          }
                        />
                      ),
                    })
                  }
                }}
                checked={currentState.issuer.data.lti_login}
                disabled={
                  !['moodle', 'desire2learn'].includes(
                    currentState.issuer.data['product_family_code']
                  )
                }
              />
              {['moodle', 'desire2learn'].includes(
                currentState.issuer.data['product_family_code']
              ) && <p>Issuers should be enabled for Brightspace and Moodle</p>}
            </div>
            <p>
              <span style={{ fontSize: '1.2em', fontWeight: 'bolder' }}>
                ID:
              </span>{' '}
              {currentState.issuer.id}
            </p>
            <p>
              <span style={{ fontSize: '1.2em', fontWeight: 'bolder' }}>
                Name:
              </span>{' '}
              {currentState.issuer.data.name}
            </p>
            <p>
              <span style={{ fontSize: '1.2em', fontWeight: 'bolder' }}>
                Connection Enabled:{' '}
              </span>{' '}
              {currentState.issuer.data.lti_login ? 'Yes' : 'No'}
            </p>
            <p>
              <span style={{ fontSize: '1.2em', fontWeight: 'bolder' }}>
                Iss:
              </span>{' '}
              {currentState.issuer.iss}
            </p>
          </div>
        )}
      </div>

      <div className="card-myed">
        <h3>Clients:</h3>
        <Table striped bordered condensed hover>
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Enabled</th>
              <th>Client ID</th>
              <th>Actions</th>
              <th>Remove</th>
            </tr>
          </thead>
          <tbody>
            {currentState.clientsTableData &&
              currentState.clientsTableData.map((clientObj, i) => (
                <tr key={i}>
                  <td>{clientObj.id}</td>
                  <td>{clientObj.data.name}</td>
                  <td>{clientObj.data.lti_login ? 'Yes' : 'No'}</td>
                  <td>{clientObj.clientid}</td>
                  <td>
                    <Link
                      to={`/account/admin_lti13/-/platforms/${match.params.lmsCode}/issuers/${match.params.issuerId}/clients/${clientObj.id}`}
                    >
                      View Client
                    </Link>
                  </td>
                  <td>
                    <a
                      onClick={() => openModal(clientObj)}
                      className="btn btn-sm btn-sm-myed btn-danger"
                    >
                      Remove <i className="far fa-window-close" />
                    </a>
                  </td>
                </tr>
              ))}
          </tbody>
          <EditIssuerModal
            show={showIssuerEditModal}
            toggle={setShowIssuerEditModal}
            issuer={currentState.issuer}
          />
          <RemoveConfirmModal
            modalTitle="Remove Client"
            message={removeContextMessage}
            endpoint={removeContextURL}
            show={removeContextModalOpen}
            toggle={toggleRemoveModal}
            currentState={currentState}
            dispatch={dispatch}
          />
        </Table>
      </div>
    </div>
  )
}
